<template>
  <div class="selection">
    <el-form
      label-position="left"
      :inline="true"
      :model="selectionForm"
      class="demo-form-inline"
    >
      <el-form-item label="锐锢编码">
        <el-input
          v-model="selectionForm.ruigu_code"
          placeholder="锐锢编码"
          @keyup.enter.native="searchGoods"
        ></el-input>
      </el-form-item>
      <el-form-item label="商品名称">
        <el-input
          v-model="selectionForm.name"
          placeholder="商品名称"
          @keyup.enter.native="searchGoods"
        ></el-input>
      </el-form-item>
      <el-form-item label="分类">
        <el-input
          v-model="selectionForm.c_name"
          placeholder="分类"
          @keyup.enter.native="searchGoods"
        ></el-input>
      </el-form-item>
      <el-form-item label="品牌">
        <el-input
          v-model="selectionForm.brand_name"
          placeholder="品牌"
          @keyup.enter.native="searchGoods"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" size="small" @click="searchGoods"
          >查询</el-button
        >
        <el-button type="primary" size="small" @click="exportGoods"
          >导出</el-button
        >
        <el-button type="primary" size="small" @click="selectGoods"
          >选品</el-button
        >
        <el-upload
          class="export-btn-drop"
          :accept="fileTypeStr"
          action=""
          :before-upload="beforeUpload"
          :http-request="httpRequest"
          :show-file-list="false"
        >
          <el-button size="small" type="primary">导入取消选品</el-button>
        </el-upload>
        <el-button type="primary" size="small" @click="handleDown"
          >下载导入模板</el-button
        >
      </el-form-item>
    </el-form>

    <classify-table
      ref="classifyTable"
      v-loading="loadingSelection"
      :TableData="TableData"
      :type="type"
    ></classify-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[10, 50, 100, 200]"
      :page-size="pagesize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="totalCount"
    >
    </el-pagination>
  </div>
</template>
<script>
import classifyTable from "@/components/basic/basic-table.vue";
import UploadExcelComponent from "@/components/common/UploadExcel/index.vue";
import {
  getSelectionGoodsList,
  goodsSelection,
  exportGoodsSelect,
  goodsCancel
} from "@/models/goodsModel";
export default {
  name: "selection",
  components: { classifyTable, UploadExcelComponent },
  data() {
    return {
      selectionForm: {
        ruigu_code: "",
        name: "",
        brand_name: "",
        c_name: ""
      },
      TableData: [],
      type: "classify",
      pagesize: 10,
      currentPage: 1,
      totalCount: 0,
      loadingSelection: true,
      selectData: [],
      //允许上传的文件类型
      fileTypeStr:
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel"
    };
  },
  mounted() {
    this.getSelectionGoodsList();
  },
  methods: {
    async selectGoods() {
      let formData = this.$refs.classifyTable.formData;
      if (formData === "" || formData.ruigu_code === "") {
        this.$message.warning("请选择商品");
      } else {
        let params = {
          ruigu_code: formData.ruigu_code
        };
        await goodsSelection(params);
        this.getSelectionGoodsList();
      }
    },
    searchGoods() {
      this.currentPage = 1;
      this.getSelectionGoodsList();
    },
    async getSelectionGoodsList() {
      this.loadingSelection = true;
      let params = {
        page: this.currentPage,
        pagesize: this.pagesize,
        c_name: this.selectionForm.c_name,
        brand_name: this.selectionForm.brand_name,
        name: this.selectionForm.name,
        ruigu_code: this.selectionForm.ruigu_code
      };
      let data = await getSelectionGoodsList(params);
      setTimeout(() => {
        this.loadingSelection = false;
      }, 300);
      if (data && data.list) {
        this.currentPage = data.page.current_page;
        this.totalCount = data.page.total;
        for (let i of data.list) {
          if (!i.productModel) {
            i.productModel = "";
          }
          if (!i.specification) {
            i.specification = "";
          }
          i.model = i.productModel + i.specification;
          i.is_sale = i.is_online === 1 ? "是" : "否";
          if (
            data.hasOwnProperty("no_stock_sku") &&
            data.no_stock_sku.indexOf(i.bianma) > -1
          ) {
            i.checkBoxType = false;
            i.className = "warning-row";
          } else {
            i.checkBoxType = true;
            i.className = "success-row";
          }
        }
        this.TableData = data.list;
      } else {
        this.currentPage = 1;
        this.totalCount = 0;
      }
    },
    handleSizeChange(val) {
      this.pagesize = val;
      this.getSelectionGoodsList();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getSelectionGoodsList();
    },
    async exportGoods() {
      let params = {
        c_name: this.selectionForm.c_name,
        brand_name: this.selectionForm.brand_name,
        name: this.selectionForm.name,
        ruigu_code: this.selectionForm.ruigu_code
      };
      await exportGoodsSelect(params);
    },
    // 文件上传格式校验
    beforeUpload(file) {
      const fileType = this.fileTypeStr.split(",");
      if (!fileType.includes(file.type)) {
        this.$message.error("请上传 excel文件！");
        return false;
      }
    },
    // 文件上传
    httpRequest(data) {
      const _this = this;
      if (data && data.file) {
        const fd = new FormData();
        fd.append("shop_id", localStorage.getItem("shop_id"));
        fd.append("token", localStorage.getItem("token"));
        fd.append("file", data.file);
        goodsCancel(fd)
          .then(res => {
            if (res) {
              this.$message("导入成功！");
              _this.$router.push({ name: "stockRecord", params: {} });
            }
          })
          .catch(err => {
            this.$message.error(err.message);
          });
      }
    },
    // 下载导入模板
    handleDown() {
      const tempUrl =
        "https://static.ruigushop.com/agent/template/取消选品导入模板.xlsx"; //模板链接
      window.open(tempUrl);
    }
  }
};
</script>
<style lang="scss">
.selection {
  .el-form {
    border-bottom: 1px dashed #999;
    padding-bottom: 5px;
  }
}

.export-btn-drop {
  display: inline-block;
}
</style>



// WEBPACK FOOTER //
// src/pages/basic/selection.vue